import { useCallback } from 'react';
import { SignupFormFields, signupFormClient } from '@bymason-private/controller-api';
import { useSaveDataHook } from '@bymason/api-hooks-base';

export { SignupFormFields, CreateAccountOptions } from '@bymason-private/controller-api';

/**
 * React hook that asynchronously submits a signup form.
 * @returns HookArray
 * @HookArray [0] submitForm method
 * @HookArray [1] void
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 */
export function useSubmitSignupForm() {
  const handleSubmitSignupForm = useCallback((data: SignupFormFields) => {
    return signupFormClient.submit(data);
  }, []);

  return useSaveDataHook(handleSubmitSignupForm);
}
